import * as actionTypes from '../constants/actionType';
import initialState from './initialState';

export default function mEventDetailReducer(state = initialState.mEventDetail, action) {
  switch (action.type) {
    case actionTypes.MEVENTDETAIL_LOAD_START:
      return {
        ...state,
        isLoading: true
      };

    case actionTypes.MEVENTDETAIL_LOAD_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.error
      };

    case actionTypes.MEVENTDETAIL_LOAD_SUCCESS: {
      return {
        ...state,
        ...action.data,
        isLoading: false,
        error: undefined
      };
    }

    default:
      return state;
  }
}
